import { render, staticRenderFns } from "./SearchPackages.vue?vue&type=template&id=0ab2e222&scoped=true&"
import script from "./SearchPackages.vue?vue&type=script&lang=js&"
export * from "./SearchPackages.vue?vue&type=script&lang=js&"
import style0 from "./SearchPackages.vue?vue&type=style&index=0&id=0ab2e222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2e222",
  null
  
)

export default component.exports